import { DrawerStack } from "./drawer-stack.factory";
import { NavDrawerDirective } from "./nav-drawer.directive";
import { NavDrawerProvider } from "./nav-drawer.provider";

import drawerContainerTpl from './drawer.template.html';
import drawerBackdropTpl from './backdrop.template.html';


let navDrawerModule = angular.module("qpui.bootstrap.navdrawer", []);

navDrawerModule
    .directive({
        navDrawer: NavDrawerDirective,
    })
    .provider({
        // navDrawer: NavDrawerProvider
    })
    .factory({
        drawerStack: DrawerStack
    })
    .run(["$templateCache", function ($templateCache) {
        $templateCache.put('drawerContainer.html', drawerContainerTpl);
        $templateCache.put('backdrop.html', drawerBackdropTpl);
    }])

export { navDrawerModule }